export const DATA_MANAGER_PATH = "/data-manager";
